import { render } from "./dashboardPuckPediaComponent.vue?vue&type=template&id=01272f2b"
import script from "./dashboardPuckPediaComponent.vue?vue&type=script&lang=js"
export * from "./dashboardPuckPediaComponent.vue?vue&type=script&lang=js"

import "./dashboardPuckPediaComponent.vue?vue&type=style&index=0&id=01272f2b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__